import { render, staticRenderFns } from "./GStudentImportUploadConfirm.vue?vue&type=template&id=1d10101c&scoped=true&"
import script from "./GStudentImportUploadConfirm.vue?vue&type=script&lang=ts&"
export * from "./GStudentImportUploadConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentImportUploadConfirm.vue?vue&type=style&index=0&id=1d10101c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d10101c",
  null
  
)

export default component.exports